import React, { SetStateAction } from 'react';

import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';

import { RecipePresetSubstep, settingsInterface } from '../../../app/recipeCreation/createRecipe.types';
import styles from './presetResetDialog.module.css';

const PresetResetDialog = ({
  resetPopUp,
  setResetPopUp,
  setIsPresetOpen,
  setSettings,
  setPresetSelected
}: {
  resetPopUp: boolean;
  setResetPopUp: React.Dispatch<SetStateAction<boolean>>;
  setIsPresetOpen: React.Dispatch<SetStateAction<boolean>>;
  setSettings: React.Dispatch<SetStateAction<Array<settingsInterface>>>;
  setPresetSelected: React.Dispatch<SetStateAction<RecipePresetSubstep | null>>;
}) => {
  const handleClose = () => {
    setResetPopUp(false);
  };

  const handleContinueButton = () => {
    setPresetSelected(null);
    setResetPopUp(false);
    setIsPresetOpen(true);
    setSettings([]);
  };

  return (
    <Dialog
      onClose={handleClose}
      open={resetPopUp}
      PaperProps={{ className: styles.dialog_paper }}
    >
      <Grid>
        <DialogContent className={styles.dialog_content}>
          <Typography variant="caption3Light">
            This will forget your current selection. Do you want to proceed?
          </Typography>
        </DialogContent>
        <DialogActions className={styles.dialog_actions}>
          <Button className={styles.cancel_button} onClick={handleClose}>
            <Typography variant="caption3Light">Cancel</Typography>
          </Button>
          <Button
            autoFocus
            className={styles.continue_button}
            onClick={handleContinueButton}
          >
            <Typography variant="caption3Light">Continue</Typography>
          </Button>
        </DialogActions>
      </Grid>
    </Dialog>
  );
};

export default PresetResetDialog;
